<jni-confirm-dialog
  [dialogMessage]="popupmessage"
  dialogHeading="Delete Confirmation"
  *ngIf="dialogStatus"
  (confirmDialogStatus)="confirmDialogStatusData($event)">
</jni-confirm-dialog>
<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">
            Users <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
          </h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-togglebutton
            onLabel="Filter"
            offLabel="Filter"
            [onIcon]="'pi pi-filter-fill'"
            offIcon="pi pi-filter"
            styleClass="w-36 p-0"
            ariaLabel="Do you confirm"
            severity="secondary"
            class="fullwdth secondary-btn btn-primecolor" />

          <p-button
            label="Delete"
            variant="text"
            severity="secondary"
            icon="pi pi-trash"
            (click)="deleteDialog()"
            class="fullwdth secondary-btn btn-primecolor" />

          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />

          <p-button
            label="Import User"
            variant="outlined"
            icon="pi pi-cloud-download"
            severity="secondary"
            [hidden]="isImportDisabled"
            *ngIf="importUserRights"
            (click)="toggleImportDrawer = !toggleImportDrawer"
            [hidden]="isImportDisabled"
            class="fullwdth secondary-btn" />

          <p-drawer
            #drawerUserImportRef
            header="Azure Active Directory Users"
            [(visible)]="toggleImportDrawer"
            position="right"
            [style]="{ width: '35vw' }">
            <jni-import-user
              *ngIf="userListings.length"
              [userListings]="userListings"
              (userListChanged)="fetchUsers($event)"
              (toggleImportDrawer)="
                toggleImportDrawer = !toggleImportDrawer
              "></jni-import-user>
          </p-drawer>
        </span>
      </span>

      <div class="col-lg-12">
        <p-table
          #dt
          stripedRows
          [value]="userListings"
          [(selection)]="selectedUsers"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [resizableColumns]="true"
          [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0"
          selectionMode="multiple"
          (onFilter)="onFilter($event)"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th class="max-width-8">Name</th>
              <th class="max-width-10">AD Login</th>
              <th class="max-width-5">Type</th>
              <th class="max-width-7">Personnel Number</th>
              <th>Active</th>
              <th>Ledger</th>
              <th>Office</th>
              <th>Title</th>
            </tr>
            <tr class="sort-row">
              <th></th>
              <th class="max-width-8">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  id="name"
                  name="name"
                  class="max-width-8"
                  (input)="
                    dt.filter($any($event.target).value, 'name', 'contains')
                  "
                  placeholder="" />
              </th>
              <th class="max-width-10">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  id="loginEmail"
                  name="loginEmail"
                  class="max-width-10"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'loginEmail',
                      'contains'
                    )
                  "
                  placeholder="" />
              </th>
              <th class="max-width-5">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  id="userRoleName"
                  name="userRoleName"
                  class="max-width-5"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'userRoleName',
                      'startsWith'
                    )
                  "
                  placeholder="" />
              </th>
              <th class="max-width-7">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  id="personnelNumber"
                  name="personnelNumber"
                  class="max-width-7"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'personnelNumber',
                      'contains'
                    )
                  "
                  placeholder="" />
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-userListing let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="userListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  [disabled]="false"
                  [pSelectableRow]="userListing"
                  [value]="userListing"></p-tableCheckbox>
              </td>
              <td>
                <a class="link" (click)="getCurrentUser(userListing)">{{
                  userListing.name
                }}</a>
              </td>
              <td>
                <span class="email-add">{{ userListing.loginEmail }}</span>
              </td>
              <td>
                <span class="image-text">{{
                  userListing?.userRoleName?.toLowerCase() === "power use"
                    ? "Power User"
                    : userListing?.userRoleName
                }}</span>
              </td>
              <td>
                <span class="image-text">{{
                  userListing?.personnelNumber
                }}</span>
              </td>
              <td
                class="d-flex justify-content-center align-items-center form-switch-hgt">
                <div class="form-check form-switch m-0 toggle-color-custom">
                  <p-toggleswitch
                    [(ngModel)]="userListing.isProfileActive"
                    (click)="onActiveSwitch(userListing, $event)"
                    id="flexSwitchCheckDefault4"
                    name="flexSwitchCheckDefault4"
                    class="toggle-switch" />
                </div>
              </td>
              <td>
                <div
                  class="d-flex justify-content-center align-items-center form-switch-hgt">
                  <div class="form-check form-switch m-0">
                    <p-toggleswitch
                      [(ngModel)]="userListing.isLedgerActive"
                      (click)="clickDisabled($event)"
                      id="flexSwitchCheckDefault3"
                      name="flexSwitchCheckDefault3"
                      class="toggle-switch" />
                  </div>
                </div>
              </td>
              <td>
                {{ userListing.locationName }}
              </td>
              <td>
                {{ userListing.title }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No users found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <jni-modal-stacker
        *ngIf="userDisplayModal"
        [displayModal]="userDisplayModal"
        (closeEvent)="closeUserModal()"
        [showHeader]="false">
        <div class="panelHeading"></div>
        <div class="panelBody">
          <jni-profile
            #profile
            [userId]="selectedUserId"
            (emitCloseProfileModal)="closeUserModal()"
            [isModal]="true"></jni-profile>
        </div>
      </jni-modal-stacker>
    </p-card>
  </div>
</div>
